import React from 'react';

const Terms = () => {
  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">Terms of Use</h1>
      <div className="mt-8 space-y-6 text-base leading-7 text-slate-700">
        <p>
          This website is provided for informational purposes only. The content is intended to share general
          financial, insurance and investment guidance in a clear and accessible way. It does not replace advice
          from a qualified professional, and it should not be interpreted as a legal, tax or financial advisory
          recommendation tailored to an individual situation.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">General information only</h2>
        <p>
          The website may include educational information about insurance products, financial planning topics,
          mutual funds and related matters. Product terms, eligibility rules, exclusions and policy conditions may
          change over time. Official insurer or scheme documents should be reviewed before making a decision.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">No guarantees</h2>
        <p>
          The website does not guarantee financial outcomes, claim approval, policy approval, tax outcomes or
          investment returns. Any discussion or guidance provided through this site should be considered general in
          nature and subject to the specific product terms and individual circumstances.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">External links</h2>
        <p>
          This website may contain links to third-party websites or external resources for convenience. These links
          are provided for informational use only, and we are not responsible for the content, accuracy, privacy
          practices or reliability of external websites.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Website content</h2>
        <p>
          The text, graphics, logos and other material on this website are intended for general informational use.
          Unless otherwise stated, this content should not be copied, reproduced or redistributed in a way that
          violates applicable law or the rights of the site owner.
        </p>

        <h2 className="text-2xl font-semibold text-slate-900">Changes</h2>
        <p>
          These terms may be updated periodically. Continued use of the website after changes are posted means the
          visitor accepts the revised terms.
        </p>
      </div>
    </div>
  );
};

export default Terms;
